import { PropsWithChildren } from 'react';

import { css } from '@emotion/react';
import { IonContent } from '@ionic/react';
import { Box, Stack } from '@mui/material';
import { ScorencoLogo } from '@scorenco/components';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const styles = (theme) => css`
  &::part(scroll) {
    display: flex;
    justify-content: start;
    align-items: stretch;
    flex-direction: column;
    padding: 0;
    margin-left: 50%;
    background-color: ${theme.vars.palette.background.paper};
    min-height: 100%;
    min-height: -webkit-fill-available;
  }
`;

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';

export const AuthentificationLayout = ({ children }: PropsWithChildren) => {
  return (
    <IonContent fullscreen css={styles}>
      <Box
        css={(theme) => css`
          position: fixed;
          top: 0;
          bottom: 0;
          left: 0;
          width: 50%;
          background-color: ${theme.vars.palette.primary.main};
        `}
      >
        <Swiper
          css={css`
            height: 100%;
            width: 100%;
          `}
          modules={[Autoplay]}
          spaceBetween={0}
          slidesPerView={1}
          autoplay={true}
          loop={true}
        >
          {[
            '/images/auth/volley-auth.jpg',
            '/images/auth/basket-1.jpg',
            '/images/auth/foot-1.webp',
            '/images/auth/hand-2.jpg',
            '/images/auth/hockey-glace-1.webp',
            '/images/auth/rugby-1.webp',
            '/images/auth/foot-2.webp',
            '/images/auth/supporters.webp',
            '/images/auth/rugby-2.webp',
          ].map((src) => (
            <SwiperSlide key={src}>
              <Box
                component="img"
                src={src}
                css={css`
                  width: 100%;
                  height: 100%;
                  min-width: 0;
                  min-height: 0;
                  object-fit: cover;
                  opacity: 0.75;
                `}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      <Box
        px={2}
        py={1}
        height="3rem"
        width="100%"
        position="absolute"
        sx={{ backgroundColor: 'background.paper', zIndex: 1000 }}
      >
        <ScorencoLogo
          sx={{
            height: '100%',
          }}
          alignSelf="start"
        />
      </Box>

      <Box maxHeight="100vh" overflow="auto" height="100%">
        <Stack
          width="100%"
          height="100%"
          alignItems="stretch"
          justifyContent="space-between"
        >
          <Box minHeight="3rem" />
          <Box mx="auto" width="100%" maxWidth="sm" p={2}>
            {children}
          </Box>
          <Box minHeight="1rem" />
        </Stack>
      </Box>
    </IonContent>
  );
};
